// extracted by mini-css-extract-plugin
module.exports = {"container":"_389d400","wrapper":"_96ca24d4","ratingWrapper":"_cd18c493"};